import React, { useId } from 'react';

import { Input } from '../ui/input';
import { PERIODES, bornesPeriode } from './argentOnglets';

/**
 * Sélecteur compact de la période, à droite de la barre d'onglets. Il remplace
 * la grande carte « Du / Au / Mois en cours ». « Dates libres » ouvre deux
 * dates sur la même ligne.
 */
export default function SelecteurPeriode({ periode, onChange }) {
  const id = useId();
  const choisir = (cle) => {
    if (cle === 'libre') onChange({ cle, du: periode.du, au: periode.au });
    else onChange({ cle });
  };
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid="selecteur-periode">
      <label htmlFor={id} className="sr-only">Période</label>
      <select
        id={id}
        value={periode.cle}
        onChange={(event) => choisir(event.target.value)}
        className="h-8 rounded-md border border-input bg-card px-2 text-sm font-medium focus:outline-none focus:ring-1 focus:ring-ring"
      >
        {PERIODES.map((cle) => (
          <option key={cle} value={cle}>
            {cle === 'libre' ? 'Dates libres…' : bornesPeriode(cle).libelle}
          </option>
        ))}
      </select>
      {periode.cle === 'libre' && (
        <>
          <Input
            type="date"
            aria-label="Du"
            value={periode.du}
            max={periode.au}
            onChange={(event) => onChange({ cle: 'libre', du: event.target.value, au: periode.au })}
            className="h-8 w-[9.5rem] px-2 text-sm"
          />
          <Input
            type="date"
            aria-label="Au"
            value={periode.au}
            min={periode.du}
            onChange={(event) => onChange({ cle: 'libre', du: periode.du, au: event.target.value })}
            className="h-8 w-[9.5rem] px-2 text-sm"
          />
        </>
      )}
    </div>
  );
}
